import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      title: 'Adicionar novo membro',
      description: 'Cadastrar um novo filiado',
      icon: 'UserPlus',
      variant: 'default',
      onClick: () => navigate('/member-registration')
    },
    {
      title: 'Importar membros',
      description: 'Importação em massa via CSV/Excel',
      icon: 'Upload',
      variant: 'outline',
      onClick: () => navigate('/member-import')
    },
    {
      title: 'Exportar dados',
      description: 'Baixar base de filiados',
      icon: 'Download',
      variant: 'secondary',
      onClick: () => console.log('Export functionality')
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Ações rápidas</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {actions?.map((action, index) => (
          <div key={index} className="text-center">
            <Button
              variant={action?.variant}
              iconName={action?.icon}
              iconPosition="left"
              onClick={action?.onClick}
              fullWidth
              className="mb-2"
            >
              {action?.title}
            </Button>
            <p className="text-xs text-muted-foreground">{action?.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;